const defaultSettings = { darkMode: false, language: 'sv-se' };

const getSettings = username => JSON.parse(localStorage.getItem(`${username}.settings`)) || defaultSettings;
const setDarkMode = (username, darkMode) => localStorage.setItem(`${username}.settings`, JSON.stringify({ ...getSettings(username), darkMode }));
const setLanguage = (username, language) => localStorage.setItem(`${username}.settings`, JSON.stringify({ ...getSettings(username), language }));

const api = {
    getSettings,
    setLanguage,
    setDarkMode,
};

export default api;
